// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__u4An+","activeHide":"Sidebar_activeHide__AJKxJ","inactive":"Sidebar_inactive__k5qNC"};